//#region src/extensions/image-extension/use-image-drop-and-upload/state.ts
var e = /* @__PURE__ */ new Set(), t = (t) => {
	e.add(t);
}, n = (t) => e.has(t), r = (t) => {
	e.add(t);
};
//#endregion
export { r as addExistingImageSrc, t as addUploadedImageSrc, n as hasUploadedImageSrc };
